import { apiClient } from './apiClient';

class RBACService {
  // Métodos para Usuários
  async getUsers(params = {}) {
    try {
      const { withCache } = await import('./cacheService');
      const cacheKey = `users_${JSON.stringify(params)}`;
      
      return await withCache(cacheKey, async () => {
        const response = await apiClient.get('/rbac/users', { params });
        return response.data;
      });
    } catch (error) {
      const response = await apiClient.get('/rbac/users', { params });
      return response.data;
    }
  }

  async getUser(userId) {
    const response = await apiClient.get(`/rbac/users/${userId}`);
    return response.data;
  }

  async createUser(userData) {
    const response = await apiClient.post('/rbac/users', userData);
    return response.data;
  }

  async updateUser(userId, userData) {
    const response = await apiClient.put(`/rbac/users/${userId}`, userData);
    return response.data;
  }

  async deactivateUser(userId) {
    await apiClient.put(`/rbac/users/${userId}/deactivate`);
  }

  async changeUserPassword(userId, passwordData) {
    await apiClient.put(`/rbac/users/${userId}/password`, passwordData);
  }

  async forceUserLogout(userId) {
    const response = await apiClient.post(`/rbac/users/${userId}/force-logout`);
    return response.data;
  }

  // Métodos para Roles
  async getRoles(params = {}) {
    try {
      const { withCache } = await import('./cacheService');
      const cacheKey = `roles_${JSON.stringify(params)}`;
      
      return await withCache(cacheKey, async () => {
        const response = await apiClient.get('/rbac/roles', { params });
        return response.data;
      });
    } catch (error) {
      const response = await apiClient.get('/rbac/roles', { params });
      return response.data;
    }
  }

  async getRole(roleId) {
    const response = await apiClient.get(`/rbac/roles/${roleId}`);
    return response.data;
  }

  async createRole(roleData) {
    const response = await apiClient.post('/rbac/roles', roleData);
    return response.data;
  }

  async updateRole(roleId, roleData) {
    const response = await apiClient.put(`/rbac/roles/${roleId}`, roleData);
    return response.data;
  }

  async deleteRole(roleId) {
    await apiClient.delete(`/rbac/roles/${roleId}`);
  }

  // Métodos para Permissões
  async getPermissions(params = {}) {
    const response = await apiClient.get('/rbac/permissions', { params });
    return response.data;
  }

  async getPermission(permissionId) {
    const response = await apiClient.get(`/rbac/permissions/${permissionId}`);
    return response.data;
  }

  async createPermission(permissionData) {
    const response = await apiClient.post('/rbac/permissions', permissionData);
    return response.data;
  }

  async updatePermission(permissionId, permissionData) {
    const response = await apiClient.put(`/rbac/permissions/${permissionId}`, permissionData);
    return response.data;
  }

  async deletePermission(permissionId) {
    await apiClient.delete(`/rbac/permissions/${permissionId}`);
  }

  // Métodos para verificação de permissões
  async getUserPermissions(userId) {
    const response = await apiClient.get(`/rbac/users/${userId}/permissions`);
    return response.data;
  }

  async checkPermission(permissionData) {
    const response = await apiClient.post('/rbac/check-permission', permissionData);
    return response.data;
  }

  async getCurrentUserInfo() {
    const response = await apiClient.get('/rbac/me');
    return response.data;
  }
}

export const rbacService = new RBACService();